export const ChevronDown: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#A1A7BA",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    fill="none"
    viewBox="0 0 14 8"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.6 1.6 7 7l5.4-5.4"
    ></path>
  </svg>
);
